import React from 'react';
import { processSteps } from '../data/mock';

const ProcessSection = () => {
  return (
    <section id="how-we-work" className="py-24 lg:py-32 bg-white relative overflow-hidden">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-30">
        <div className="absolute top-20 left-20 w-64 h-64 bg-rose-200 rounded-full blur-3xl" />
        <div className="absolute bottom-20 right-20 w-64 h-64 bg-amber-200 rounded-full blur-3xl" />
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16 md:mb-20">
          <span className="inline-block text-sm font-bold text-teal-600 uppercase tracking-wider mb-4 px-4 py-2 bg-teal-50 rounded-full">
            The Process
          </span>
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-black text-slate-900 mb-6">
            How we make the
            <br />
            <span className="bg-gradient-to-r from-teal-500 to-emerald-500 bg-clip-text text-transparent">magic happen</span>
          </h2>
        </div>

        {/* Process Steps - Creative Layout */}
        <div className="relative">
          {/* Connection line */}
          <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-1 bg-gradient-to-r from-rose-200 via-orange-200 via-amber-200 to-emerald-200 -translate-y-1/2 rounded-full" />

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
            {processSteps.map((step, index) => (
              <div
                key={step.id}
                className={`relative group ${
                  index % 2 === 0 ? 'lg:pt-0' : 'lg:pt-20'
                }`}
              >
                {/* Step card */}
                <div className="relative bg-white rounded-3xl p-6 md:p-8 shadow-xl shadow-slate-200/50 border-2 border-slate-100 group-hover:border-rose-200 group-hover:shadow-2xl group-hover:shadow-rose-200/30 transition-all duration-500 group-hover:-translate-y-2">
                  {/* Step number bubble */}
                  <div className="absolute -top-6 left-6 md:left-8 w-12 h-12 rounded-2xl bg-gradient-to-br from-rose-500 to-orange-500 flex items-center justify-center text-white font-black text-lg shadow-lg shadow-rose-500/30 group-hover:scale-110 transition-transform">
                    {step.step}
                  </div>

                  {/* Visual emoji */}
                  <div className="text-4xl md:text-5xl mb-4 md:mb-6 mt-4 group-hover:scale-110 transition-transform">
                    {step.visual}
                  </div>

                  <h3 className="text-xl md:text-2xl font-black text-slate-900 mb-2">
                    {step.title}
                  </h3>
                  <p className="text-rose-500 font-semibold mb-4">
                    {step.subtitle}
                  </p>
                  <p className="text-slate-600 leading-relaxed text-sm md:text-base">
                    {step.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
